import {faLocationDot} from "@fortawesome/sharp-solid-svg-icons/faLocationDot";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Campus from "../../types/Campus";
import clsMerge from "../../util/clsMerge";
import AddressLink from "../AddressLink";

type NavLocationClasses = {
	root?: string;
	overviewRoot?: string;
	detailsRoot?: string;
};

/**
 * REVIEW: Variants.  This is a little shady, overlapping with Tailwind's
 * default variant names.
 *
 * But.
 *
 * I can't think of a set of names that is sufficiently generic (e.g. mobile vs
 * desktop would imply a use case for each variant).
 */
export enum NavLocationVariants {
	light = "light",
	dark = "dark",
}

/**
 * Define variant classes and mapping.
 */
const lightVariantClasses = {
	overviewRoot: "bg-green-800 text-white p-4",
	detailsRoot: "py-4 px-6 bg-gray-50",
};

const darkVariantClasses = {
	root: "text-white",
	detailsRoot: "rounded-lg bg-green-900 bg-opacity-90",
};

const variantClassesMap: Record<NavLocationVariants, NavLocationClasses> = {
	light: lightVariantClasses,
	dark: darkVariantClasses,
};

const NavLocation: React.FC<{
	data: Campus | null;
	classes?: NavLocationClasses;
	variant?: NavLocationVariants;
}> = ({data: campusData, classes, variant = NavLocationVariants.dark}) => {
	const variantClasses = variantClassesMap[variant];
	const isDark = variant === NavLocationVariants.dark;
	const email = `${campusData?.campusId}@aopsacademy.org`;
	return (
		<div className={clsMerge(variantClasses.root, classes?.root)}>
			<div
				className={clsMerge(
					"flex flex-row flex-wrap items-center gap-x-3 py-2",
					variantClasses.overviewRoot,
					classes?.overviewRoot
				)}
			>
				<div>Your Home Campus:</div>
				<div className="flex items-center gap-2 overflow-hidden whitespace-nowrap rounded-full bg-green-900 px-3 py-1">
					<FontAwesomeIcon icon={faLocationDot} />
					{`${campusData?.city}, ${campusData?.stateAbbreviation}`}
				</div>
			</div>
			<div
				className={clsMerge(
					"flex flex-col gap-x-4 gap-y-2 p-4 text-body-1",
					variantClasses.detailsRoot,
					classes?.detailsRoot
				)}
			>
				{campusData?.address && (
					<>
						<AddressLink address={campusData?.address} noLinkStyling={isDark} />
					</>
				)}
				<a href={`tel:+1${campusData?.phoneNumber}`}>
					{campusData?.phoneNumber}
				</a>
				<a
					className={clsMerge(
						// break-all here is just in case to make it not overflow, shouldn't usually matter
						"break-all",
						isDark ? "underline" : "text-hyperlink"
					)}
					href={`mailto:${email}`}
				>
					{email}
				</a>
			</div>
		</div>
	);
};

export default NavLocation;
